import { axios } from "../axios.instance";

export type DeleteAccountRequest = null;

export type DeleteAccountResponse = null;

export const deleteAccount = async (): Promise<DeleteAccountResponse> => {
  const { data } = await axios.delete("users/me/delete");

  return data;
};
